import { Component ,Inject} from '@angular/core';
import { DOCUMENT } from '@angular/common';

@Component({
  selector: 'app-maintainance',
  templateUrl: './maintainance.component.html',
  styleUrls: ['./maintainance.component.scss']
})
export class MaintainanceComponent {

  constructor(@Inject(DOCUMENT) private document: Document) {}

  ngOnInit(): void {
    const elements = this.document.getElementsByClassName('outer-wrapper');
    Array.from(elements).forEach((el: Element) => {
     
      (el as HTMLElement).style.paddingBottom= '0px'
       console.log("elem",el)
    });
  
  }
}
